export const TRACK = 'track';
export const PAGE = 'page';
export const IDENTIFY = 'identify';
export const GROUP = 'group';
export const ALIAS = 'alias';
export const RESET = 'reset';
